import React from 'react'

const Cancel = () => {
  return (
    <div style={{display:'flex', justifyContent:'center', textAlign:'center' }}>
    <div class="card">
        <h1>Cancelled X</h1>
        <p>Payment Cancel<br/> we'll be in touch shortly!</p>
      </div>
      </div>
  )
}

export default Cancel